/* eslint-disable */
import mutations from './mutations'
import actions from './actions'

export default {
  state: {
    reportCard: null,
    reportCards: null,
    dateOfReport: null,
    reportCardOldState: null
  },
  mutations,
  actions
};
